import LinkIcon from '@/app/icons/link'
import { IGif } from '@giphy/js-types'
import { getContentOfGif, getCreatorOfGif, setGADataLayer } from 'analytics'
import { useContext } from 'react'
import { ShareUrlRenditions } from 'utils/src/media/sharing'
import { getShareUrl } from 'utils/src/url'
import { FlashMessageContext } from '../../../context/flash-message'

type Props = {
    gif: IGif
    isClip?: boolean
}

const ClipboardButton = ({ gif, isClip = false }: Props) => {
    const { showMessage } = useContext(FlashMessageContext)
    const {
        url,
        images: {
            original: { url: mediaUrl },
        },
    } = gif
    const clipboardUrl = !isClip ? getShareUrl(mediaUrl) : url
    return (
        <LinkIcon
            className="fill-giphyWhite size-5 transition-transform hover:scale-125"
            onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                navigator.clipboard.writeText(clipboardUrl)
                showMessage({ message: 'Link copied to clipboard!', type: 'success' })
                setGADataLayer({
                    event: 'share_success',
                    options: {
                        social: {
                            socialChannel: 'share',
                        },
                        content: getContentOfGif(gif, {
                            rendition: ShareUrlRenditions.Original,
                            format: gif.images.original.url,
                        }),
                        creator: getCreatorOfGif(gif),
                    },
                })
            }}
        />
    )
}

export default ClipboardButton
